module.exports = window["react"];